import { createAsyncAction, action } from 'typesafe-actions';
import { HttpStatus } from 'client/ErrorHandler';
import { ExportsTypes, ExportsResponse, ExportsRequestPayload } from './types';

const exportsActions = createAsyncAction(
  ExportsTypes.ExportsRequest,
  ExportsTypes.ExportsSuccess,
  ExportsTypes.ExportsFailure
)<ExportsRequestPayload, ExportsResponse, HttpStatus>();

export const clearList = () => action(ExportsTypes.ClearExportsList);

export default exportsActions;
